// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"97ba9401","160":"1b02765a","208":"058f33b7","293":"4a500116","488":"7d54fe3e","516":"20482701","519":"ae0b9925","917":"ebd93b50","946":"962c6eb1"}[chunkId] + ".chunk.js";
};